import { render, staticRenderFns } from "./addFlightRoute.vue?vue&type=template&id=068b3d57&scoped=true&"
import script from "./addFlightRoute.vue?vue&type=script&lang=ts&"
export * from "./addFlightRoute.vue?vue&type=script&lang=ts&"
import style0 from "./addFlightRoute.vue?vue&type=style&index=0&id=068b3d57&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068b3d57",
  null
  
)

export default component.exports